module.exports = __webpack_public_path__ + "src/assets/img/cmdProg1.5e7d8c24.svg";